import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class POCloseRequest {
    @ApiProperty()
    @IsNotEmpty()
    purchaseOrderId: number;

    @ApiProperty()
    @IsNotEmpty()
    reasonClosing?: string;
}